import { db } from '.././firestoreConfig';
import { collection, addDoc, getDocs, query, where,limit,doc,setDoc, orderBy} from "firebase/firestore"

class ProductDataService {
    async copyProduct(){
        try{
            let prod = await this.getProductBySlug('bloembollen-blauwe-druiven');
            const docRef = doc(db, `catalog/bloembollen-paasbloemen`);
            await setDoc(docRef, prod[0], { merge: true });
        }catch(error){
            const errorCode = error.code;
            const errorMessage = error.message;
            console.error("Error: ", errorCode, errorMessage);   
        }
    }
    async getProductBySlug(slug) {
        var prod = [];
        const product = query(collection(db, 'catalog'), where("slug", "==", slug));
        const querySnapshot = await getDocs(product);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, ' => ', doc.data());
            prod.push(doc.data());
            return prod;
            //return true
        }); 
        return prod;
    }
    async getProductByCategory(cat) {
        var prod = [];
        const product = query(collection(db, 'catalog'), where("category", "==", cat), where("active", "==", true));
        const querySnapshot = await getDocs(product);
        querySnapshot.forEach((doc) => {
           // console.log(doc.id, ' => ', doc.data());
            prod.push(doc.data());
            return true;
        }); 
        return prod;
    }
    async getRelated(id, max, cat) {
        const colRef = query(
            collection(db, 'catalog'), 
            where("active", "==", true), 
            where("category", "==", cat), 
            where("type", "==", 'product'), 
            where("id", "!=", parseInt(id)),
            orderBy('name','desc'),
            limit(parseInt(max))
        );
        var docs = [];
        const querySnapshot = await getDocs(colRef);
        querySnapshot.forEach((doc) => {
            if(doc.exists){
                //console.log(doc.id, " => ", doc.data());
                docs.push(doc.data());
            }
        });
        return docs;
    }
    async getAll() {
        const colRef = query(collection(db, 'catalog'), where("active", "==", true), where("type", "==", 'product'))
        var docs = [];
        const querySnapshot = await getDocs(colRef);
        querySnapshot.forEach((doc) => {
            if(doc.exists){
                //console.log(doc.id, " => ", doc.data());
                docs.push( doc.data());
            }
        });

        return docs;
    }
    async getTickets() {
        const colRef = query(collection(db, 'catalog'), where("active", "==", true), where("type", "==", 'ticket'))
        var docs = [];
        const querySnapshot = await getDocs(colRef);
        querySnapshot.forEach((doc) => {
            if(doc.exists){
                //console.log(doc.id, " => ", doc.data());
                docs.push( doc.data());
            }
        });

        return docs;
    }
    async getCategories() {
        // Fetch all active stores/categories
        const colRef = query(collection(db, 'catalog'), where("active", "==", true), where("type", "==", 'category'))
        var docs = [];
        const querySnapshot = await getDocs(colRef);
        querySnapshot.forEach((doc) => {
            if(doc.exists){
                docs.push( doc.data());
            }
        });
        return docs;
    }
    async createUser() {
        // 'users' collection reference
        const colRef = collection(db, 'users')
        // data to send
        const dataObj = {
          firstName: 'Nicky',
          lastName: 'P',
          dob: '1990'
        }

        const docRef = await addDoc(colRef, dataObj);
        console.log('Document was created with ID:', docRef.id)
    }
}

export default new ProductDataService();